import { render } from "./LastCommentView.vue?vue&type=template&id=79437625"
import script from "./LastCommentView.vue?vue&type=script&lang=js"
export * from "./LastCommentView.vue?vue&type=script&lang=js"

import "./LastCommentView.vue?vue&type=style&index=0&id=79437625&lang=css"

import exportComponent from "C:\\Users\\AloneX\\taipeitest\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__